<div class="card-body">
    <div id="apex-dashed-linechart"></div>
</div>